import { render } from "./NotificationListPage.vue?vue&type=template&id=61a663ac"
import script from "./NotificationListPage.vue?vue&type=script&lang=ts"
export * from "./NotificationListPage.vue?vue&type=script&lang=ts"
script.render = render

export default script